export const ADD = 'add'
export const REMOVE = 'remove'
export const CLEAR = 'clear'
